<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} Hiatus
            </h2>
            <v-form name="editForm" ref="editForm">
                <div class="tw-flex tw-flex-row tw-justify-between">
                    <date-picker
                        v-model="modelObject.date_start"
                        dense
                        hide-details="auto"
                        color="primary"
                        display-label="Start Date"
                        :rules="[rules.required]"
                        reactive
                        ref="datePicker"
                        :error-messages="errors?.date"
                    />
                    <date-picker
                        v-model="modelObject.date_end"
                        dense
                        hide-details="auto"
                        color="primary"
                        display-label="End date"
                        :rules="[]"
                        reactive
                        ref="datePicker2"
                        :error-messages="errors?.date_end"
                    />
                </div>
                <v-text-field
                    v-model="modelObject.comment"
                    label="Comment"
                    class="mt-4"
                ></v-text-field>
            </v-form>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="archiveProductionHiatus()"
                    class="main-btn"
                    :loading="archiveLoading"
                    v-show="is_edit_mode"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker";
import WYSIWYG from "@/Generic/WYSIWYG";

export default {
    name: "EditProductionHiatusModal",
    components: {
        DatePicker,

    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: true
        },
        'valuelists': {
            type: Object,
            required: false
        },
        'productionId': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Number,
            required: false
        },
    },
    data() {
        return {
            dialog: this.value || false,
            production_id: this.productionId || '',
            valuelist: this.valuelists,
            mode: 'Add',
            errors: null,
            communication: null,
            modelObject: this.modelProp || {},
            modelDefault: {
                id: null,
                production_id: null,
                date_start: null,
                date_end: null,
                comment: null,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            archiveLoading: false,
        }
    },
    mounted() {

    },
    computed: {
        dialog_width() {
            return '40%'
        },
        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        }
    },
    methods: {
        loadHiatusDetails() {
            if (this.modelProp === null) {
                this.mode = 'Add';
                this.modelObject = structuredClone(this.modelDefault);
            } else {
                this.mode = 'Edit';
                this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)));
            }
        },
        validateEndDate() {
            if (this.modelObject.date_start && this.modelObject.date_end) {
                const startDate = new Date(this.modelObject.date_start)
                const endDate = new Date(this.modelObject.date_end)

                if (endDate <= startDate) {
                    this.errors = {
                        date_end: 'End date must be after start date.'
                    }
                } else {
                    this.errors = null
                }
            }
        },
        activeOption(option) {
            if( this.activeOptions.includes(option) ){
                return true
            }
            return false
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        resetForm() {
            this.modelObject = structuredClone(this.modelDefault)
            this.$refs.editForm.resetValidation()
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
                this.resetForm()
            }
        },
        saveModel() {

            if (this.$refs.editForm.validate()) {
                let formData = new FormData()

                if (this.modelObject.date_start && this.modelObject.date_end) {
                    const startDate = new Date(this.modelObject.date_start)
                    const endDate = new Date(this.modelObject.date_end)

                    if (endDate <= startDate) {
                        this.errors = {
                            date_end: 'End date must be after start date.'
                        }
                        return
                    }
                }

                for (let key in this.modelObject) {
                    if (this.modelObject[key] !== null
                        && this.modelObject[key] !== undefined
                        && this.modelObject[key] !== 'undefined'
                    ) { // Adding three as system is not stable with this from time to time
                        formData.append(key, this.modelObject[key]);
                    } else {
                        formData.append(key, '');
                    }
                }

                var url = ''

                if( this.is_edit_mode ) {
                    url = route('productionshiatus.update', this.modelObject.id)
                    formData.append("_method", "put")
                } else {
                    formData.append("production_id", this.production_id)
                    url = route('productionshiatus.store')
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.resetForm()
                            this.$emit('successful-hiatus-save')
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error);
                    })

            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },

        async archiveProductionHiatus()
        {
                if (await this.$root.confirm.open(`Delete Production Hiatus`, `You are about to delete ${this.modelObject.date_start}`)) {

                    let method = 'delete'
                    let url = route('productionshiatus.destroy', this.modelObject.id)

                    axios({
                        method: method,
                        url: url,
                        data: this.modelObject,
                        onUploadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Production Hiatus has been deleted')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.archiveLoading = false
                                this.$emit('successful-hiatus-save')
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response.data.message)
                            this.archiveLoading = false
                        })
                }
        },

    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput;

            if (newInput) {
                this.loadHiatusDetails();
            } else {
                this.resetForm();
            }
        },
        dialog(newDialog, oldDialog) {

            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.activeEditor1 = false
                this.$refs.editForm.reset()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
        'modelObject.date_start'(newDate) {
            if (typeof this.$refs.datePicker !== 'undefined'){
                this.$refs.datePicker.date_temp = newDate
                this.validateEndDate()
            }
        },

        'modelObject.date_end'(newDate) {
            if (typeof this.$refs.datePicker2 !== 'undefined'){
                this.$refs.datePicker2.date_temp = newDate
                this.validateEndDate()
            }
        },
    },
}
</script>
<style scoped>
</style>
